module.exports = __webpack_public_path__ + "img/dengling.171cda18.png";